module.exports = __webpack_public_path__ + "static/media/img-about-usp1@2x.2da3349f.jpg";